import { useState } from 'react';
import {
  AppBar,
  IconButton,
  Toolbar,
  Box,
  Menu,
  MenuItem,
  Avatar,
} from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
import { useSyles } from './styles';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../../redux/auth/thunks';
import { RootState } from '../../../domain/models/RootState';
import SelectWarehouse from 'src/components/Warehouses/selectWarehouse/selectWarehouse';

const Header = ({ onOpenMenu }: any) => {
  const classes = useSyles();
  const { token, user, name, role_name } = useSelector(
    (state: RootState) => state.auth
  );
  const title = useSelector((state: RootState) => state.renovation.title);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch<any>(logout())
      .unwrap()
      .then(() => {
        window.location.href = '/login';
      });
  };

  return (
    <AppBar
      className={`${classes.appBar} rounded-b-3xl pb-0.5 !shadow-xl`}
      color='primary'
      position='fixed'
    >
      <Toolbar>
        {token && (
          <IconButton
            className={classes.menuIcon}
            edge='start'
            color='inherit'
            aria-label='menu'
            href=''
            onClick={() => onOpenMenu()}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Box className={classes.logo}>
          <img
            alt='logo-keys'
            src={'/logo-keys.png'}
            style={{ objectFit: 'contain' }}
            width={60}
            height={60}
          />
        </Box>
        {/* <div className={classes.title}>Administrador llaves</div> */}
        <div className={classes.subtitle}>{title}</div>

        {token && (
          <>
            <SelectWarehouse />
            <Box
              className={classes.pointer}
              onClick={(event) => handleMenuOpen(event)}
            >
              <div className={classes.outherinfo}>
                <span className={classes.roleName}>{name}</span>
              </div>
              <Avatar alt={name} className={classes.avatar} />
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              className={classes.menu}
            >
              <MenuItem>
                <Box
                  display='flex'
                  flexDirection='column'
                  alignItems='center'
                  justifyContent='center'
                >
                  <Avatar alt={name} src={''} className={classes.avatar} />
                  <Box marginTop={1}>{role_name}</Box>
                  <Box marginTop={1}>{user}</Box>
                </Box>
              </MenuItem>
              <MenuItem onClick={() => handleLogout()}>Salir</MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
